import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        (El prelego-alvoko de deputito Z. dum unu el fakaj kongresoj):
      </p>
      <p class="mb-3" style="padding-left: 40px;">
        «Ni devas konstati tre bedaŭrindan aferon: en nia mondo tute mankas demokratio! 
      </p>
      <p class="mb-3" style="padding-left: 40px;">
        Nur pripensu: da ni estas ĉ. 40 trilionoj, kaj da ili – nur 90 miliardoj! 
        Kia terura disproporcio! 
        Kia barbara subpremo, netolerebla en la nuna progresiva mondo! Ni laboras por ili, liverante la manĝaĵon, – sed kion faras ili? 
        Ĉu vere «gvidas», kiel ili asertas? 
        Kiu bezonas tian «gvidadon»?! 
        Ni proklamas «kulturon de abdiko», kie ne plu estas loko por privilegiitaj rasoj kaj stratumoj; 
        ni ĉiuj estas egalaj kaj neniu rajtas pretendi elstaran pozicion pro siaj apartaj meritoj kaj trajtoj. 
      </p>
      <p class="mb-3" style="padding-left: 40px;">
        Ni ekstaru por niaj naturaj rajtoj kaj liberigu nin de tiu putra, kaduka ideo de plivaloro de Iuj individuoj kompare al aliuj. 
        Ek al demokratio!»
      </p>
      <p class="mb-3">
        Tiel la mikroorganismoj de homa korpo, precipe el la dika intesto, unuanime ribelis kontraŭ cerbaj ĉeloj kaj decidis ne plu nutri ilin. Kompreneble, ili venkis: la demokratio estas ĉiopova. 
      </p>
      <p class="mb-3">
        La homo mortis. 
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Ek al demokratio!'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;